import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  forwardRef,
} from '@angular/core';
import { FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepicker, MatDatepickerInput, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { TranslateModule } from '@ngx-translate/core';
import * as moment from 'moment';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { QuillModule } from 'ngx-quill';
import { QuillConfiguration } from 'src/app/components/models/quillConfiguration';
import { FilterOptionsPipe } from 'src/app/pipes/filter.pipe';
import { FormlyApiService } from 'src/app/service/formly-api.service';
@Component({
  selector: 'app-tooltip-wrapper',
  standalone:true,
  imports:[
    NgbTooltipModule,
    CommonModule,MatFormFieldModule,FormsModule,MatTooltipModule,
    QuillModule,MatFormFieldModule,
    MatRadioModule,ReactiveFormsModule,MatInputModule,MatDatetimepickerModule,
    NgxMatSelectSearchModule,
    FormlyMaterialModule,MatIconModule,
    MatSelectModule,MatDatepickerModule,TranslateModule,FilterOptionsPipe,FormsModule
  ],
  template: `
  <div
    class="formly-tooltip-wrapper"
    [ngClass]="{
      'invalid-field':
        field.formControl?.invalid && field.formControl?.touched
    }"
  >
    <label
      *ngIf="
        field.type !== 'select' &&
        field.type !== 'input' &&
        field.type !== 'textarea' &&
        field.type !== 'radio' &&
        field.type !== 'number' &&
        field.type !== 'datepicker' &&
        field.type !== 'date-time-picker' &&
        field.type != 'checkbox' &&
        field.type !== 'quill-editor'
      "
      class="space"
    >
      <mat-label>
        <span class="label"
          ><span
            ><em
              *ngIf="to.labelIcon"
              class="fa {{ to.labelIcon || '' }}"
            ></em>
            {{ to.label }}</span
          >
          <span *ngIf="to.required" class="required-icon">*</span>
        </span>

        <!-- <mat-icon
          *ngIf="to['tooltip']"
          matTooltip="{{ to['tooltip'] }}"
          class="tooltipIcon"
          matTooltipPosition="right"
          >help</mat-icon
        > -->
      </mat-label> </label
    >
    <ng-container
      *ngIf="
        field.type !== 'select' &&
        field.type !== 'input' &&
        field.type !== 'radio' &&
        field.type !== 'textarea' &&
        field.type !== 'datepicker' &&
        field.type !== 'date-time-picker' &&
        field.type !== 'quill-editor' &&
        field.type !== 'checkbox' &&
        (to['tooltip']||to['isTooltipVideoNeeded'])
      "
      [ngClass]="{
        'd-none': field?.templateOptions?.hasOwnProperty('grid')
      }"
    >
    <!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (mouseenter)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4">
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
    <!-- <video width="550" height="300" controls>
     <source type="video/mp4" [src]="videoUrl"/>
    </video> -->

    <iframe (mousedown)="$event.stopPropagation()"
    [src]="videoUrl"
    width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
   </iframe>
  </div>
</ng-template>
    </ng-container>
    <br
      *ngIf="
        field.type !== 'select' &&
        field.type !== 'input' &&
        field.type !== 'radio' &&
        field.type !== 'textarea' &&
        field.type !== 'number' &&
        field.type !== 'datepicker' &&
        field.type !== 'date-time-picker' &&
        field.type !== 'quill-editor' &&
        field.type !== 'checkbox'
      "
    />

    <!-- <ng-container #fieldComponent></ng-container> -->
    <ng-container
      *ngIf="
        field.type !== 'select' &&
          field.type !== 'input' &&
          field.type !== 'radio' &&
          field.type !== 'textarea' &&
          field.type !== 'number' &&
          field.type !== 'datepicker' &&
          field.type !== 'date-time-picker' &&
          field.type !== 'quill-editor';
        else selectField
      "
    >
      <div *ngIf="field.type != 'checkbox'; else customField">
        <ng-container #fieldComponent></ng-container>
      </div>
      <ng-template #customField>
        <mat-checkbox
          id="{{ field.key }}"
          class="formly-field-mat-checkbox mt-3"
          [formControl]="field.templateOptions.customControl"
          ><span
            ><span
              ><em
                *ngIf="to.labelIcon"
                class="fa {{ to.labelIcon || '' }}"
              ></em>
              {{ to.label }}</span
            >
            <span *ngIf="to.required" class="required-icon">*</span>
          </span>

          <!-- <mat-icon
            *ngIf="to['tooltip']"
            matTooltip="{{ to['tooltip'] }}"
            class="tooltipIcon"
            matTooltipPosition="right"
            >help</mat-icon
          > -->
          <!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (mouseenter)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4">
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
    <!-- <video width="550" height="300" controls>
     <source type="video/mp4" [src]="videoUrl"/>
    </video> -->

    <iframe (mousedown)="$event.stopPropagation()"
    [src]="videoUrl"
    width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
   </iframe>
  </div>
</ng-template>
          </mat-checkbox
        >
      </ng-template>
      <div class="" *ngIf="showError && !to?.grid">
        <mat-error *ngIf="field.formControl?.errors&&!field.props.readOnly">
          {{ getFirstErrorMessage(field.formControl?.errors) }}
        </mat-error>
      </div>
    </ng-container>

    <ng-template #selectField>
      <div
        *ngIf="field.type === 'select'"
        class="input-wrappers"
      >
        <mat-form-field style="width:100%" floatLabel="always">
          <label>
            <mat-label>
              <span class="label"
                ><span
                  ><em
                    *ngIf="to.labelIcon"
                    class="fa {{ to.labelIcon || '' }}"
                  ></em>
                  {{ to.label }}</span
                >
                <span *ngIf="to.required" class="required-icon">*</span></span
              >
              <!-- <mat-icon
                *ngIf="to['tooltip']"
                matTooltip="{{ to['tooltip'] }}"
                class="tooltipIcon"
                matTooltipPosition="right"
                >help</mat-icon
              > -->
            </mat-label>
          </label>
          
          <ng-container *ngIf="field.type === 'select'">
<!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4">
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
    <!-- <video width="550" height="300" controls>
     <source type="video/mp4" [src]="videoUrl"/>
    </video> -->
    
        <iframe (mousedown)="$event.stopPropagation()"
         [src]="videoUrl"
         width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
  </div>
</ng-template>
</ng-container>

          <mat-select [panelClass]="'custom-dropdown-panel'"
            id="{{ field.key }}"
            *ngIf="!to.isOnloadAPICall"
            multiple="{{
              to.hasOwnProperty('multiple') && to.multiple == true
                ? true
                : false
            }}"
            [ngClass]="{'hide-dropdown': getReadonly()}"
            [formControl]="field.templateOptions.customControl"
            [placeholder]="to.placeholder"
            panelClass="custom-select-panel"
            [disabled]="getDisable()"
            (click)="getOptions()"
            (openedChange)="onDropdownOpened($event)"
             [disabled]="getReadonly() || getDisable()"
          >
            @if( getOptions().length != 0){
            <mat-option>
              <ngx-mat-select-search
                #searchInput
                [placeholderLabel]="'search_placehoalder' | translate"
                noEntriesFoundLabel="'No data found'"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="
                let option of getOptions()
                  | filterOptions
                    : searchInput.value
                    : (to.labelProp ? to.labelProp : 'label')
              "
              [value]="option[to.valueProp ? to.valueProp : 'value']"
              ><span
                ><em class="fa {{ option.icon }}"></em>
                {{ option[to.labelProp ? to.labelProp : 'label'] }}</span
              >
              <span
                *ngIf="
                  option['isValueTooltipNeed'] &&
                  option['valueTooltipText'] != ''
                "
              >
                <mat-icon
                  *ngIf="option['valueTooltipType'] == 'plain'"
                  matTooltip="{{ option['valueTooltipText'] }}"
                  class="tooltipValueIcon valueIcon"
                  matTooltipPosition="right"
                  >help</mat-icon
                >
                <ng-container *ngIf="option['valueTooltipType'] == 'html'">
                  <em
                    class="fas fa-question-circle icon"
                    [ngbTooltip]="htmlContent"
                    #t="ngbTooltip"
                    (click)="t.open(); $event.stopPropagation()"
                    triggers="mouseenter"
                    tooltipClass="my-custom-class"
                    placement="right"
                  ></em>

                  <ng-template #htmlContent class="ml-4">
                    <div [innerHTML]="option['valueTooltipText']"></div>
                  </ng-template>
                </ng-container>
              </span>
            </mat-option>
            }@else{
            <mat-option> No Data Found </mat-option>
            }
          </mat-select> 
          <mat-select [panelClass]="'custom-dropdown-panel'"
            *ngIf="to.isOnloadAPICall"
            multiple="{{
              to.hasOwnProperty('multiple') && to.multiple == true
                ? true
                : false
            }}"
            disableOptionCentering
            id="{{ field.key }}"
            [ngClass]="{'hide-dropdown': getReadonly()}"
            [formControl]="field.templateOptions.customControl"
            [placeholder]="to.placeholder"
            [disabled]="getDisable()"
            panelClass="custom-select-panel"
            (click)="getOptions()"
             [disabled]="getReadonly() || getDisable()"
            (openedChange)="onDropdownOpened($event)"
          >
            @if( getOptions().length != 0){
            <mat-option>
              <ngx-mat-select-search
                #searchInput
                [placeholderLabel]="'search_placehoalder' | translate"
                noEntriesFoundLabel="'No data found'"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="
                let option of getOptions()
                  | filterOptions
                    : searchInput.value
                    : (to.labelProp ? to.labelProp : 'label')
              "
              [value]="option[to.valueProp ? to.valueProp : 'value']"
              ><span
                ><em class="fa {{ option.icon }}"></em>
                {{ option[to.labelProp ? to.labelProp : 'label'] }}</span
              >
              <span
                *ngIf="
                  option['isValueTooltipNeed'] &&
                  option['valueTooltipText'] != ''
                "
              >
                <mat-icon
                  *ngIf="option['valueTooltipType'] == 'plain'"
                  matTooltip="{{ option['valueTooltipText'] }}"
                  class="tooltipValueIcon valueIcon"
                  matTooltipPosition="right"
                  >help</mat-icon
                >
                <ng-container *ngIf="option['valueTooltipType'] == 'html'">
                  <em
                    class="fas fa-question-circle icon"
                    [ngbTooltip]="htmlContent"
                    #t="ngbTooltip"
                    (click)="t.open(); $event.stopPropagation()"
                    triggers="mouseenter"
                    tooltipClass="my-custom-class"
                    placement="right"
                  ></em>

                  <ng-template #htmlContent class="ml-4">
                    <div [innerHTML]="option['valueTooltipText']"></div>
                  </ng-template>
                </ng-container>
              </span>
            </mat-option>
            }@else{
            <mat-option> No Data Found </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="" *ngIf="showError">
          <mat-error *ngIf="field.formControl?.errors&&!field.props.readOnly">
            {{ getFirstErrorMessage(field.formControl?.errors) }}
          </mat-error>
        </div>
      </div>

      <div
        *ngIf="field.type === 'input'"
        class="input-wrappers"
      >
        <mat-form-field
          style="width:100%"
          floatLabel="always"
          [ngClass]="{
            'mat-form-field-disabled': getDisable() || getReadonly(),
            'mat-form-field-invalid':
              field.formControl?.invalid &&
              (field.formControl?.dirty || field.formControl?.touched),
            '': !getDisable() || !getReadonly()
          }"
        >
          <label>
            <mat-label>
              <span class="label"
                ><span
                  ><em
                    *ngIf="to.labelIcon"
                    class="fa {{ to.labelIcon || '' }}"
                  ></em>
                  {{ to.label }}</span
                >
                <span *ngIf="to.required" class="required-icon">*</span></span
              >
              <!-- <mat-icon
                *ngIf="to['tooltip']"
                matTooltip="{{ to['tooltip'] }}"
                class="tooltipIcon"
                matTooltipPosition="right"
                >help</mat-icon
              > -->
            </mat-label>
          </label>
          <ng-container *ngIf="field.type === 'input' &&  (to['tooltip']||to['isTooltipVideoNeeded'])">
            <!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (mouseenter)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4">
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
    <!-- <video width="550" height="300" controls>
     <source type="video/mp4" [src]="videoUrl"/>
    </video> -->
    <iframe (mousedown)="$event.stopPropagation()"
     [src]="videoUrl"
     width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
  </div>
</ng-template>
        </ng-container>
          <input
            matInput
            id="{{ field.key }}"
            placeholder="{{ to.placeholder }}"
            *ngIf="!to['type']"
            [disabled]="true"
            [formControl]="field.templateOptions.customControl"
            [readonly]="getReadonly() || getDisable()"
          />
          <input
            matInput
            id="{{ field.key }}"
            type="text"
            placeholder="{{ to.placeholder }}"
            *ngIf="to['type'] == 'text'"
            [formControl]="field.templateOptions.customControl"
            [readonly]="getReadonly() || getDisable()"
          />
          <input
            matInput
            id="{{ field.key }}"
            type="date"
            placeholder="{{ to.placeholder }}"
            *ngIf="to['type'] == 'date'"
            [formControl]="field.templateOptions.customControl"
            [readonly]="getReadonly() || getDisable()"
          />
          <input
  matInput
  id="{{ field.key }}"
  [type]="hide ? 'password' : 'text'"
  placeholder="{{ to.placeholder }}"
  *ngIf="to['type'] == 'password'"
  [formControl]="field.templateOptions.customControl"
  [readonly]="getReadonly() || getDisable()"
/>
           <!-- Toggle icon for password visibility -->
<button *ngIf="to['type'] == 'password'"
  mat-icon-button
  matSuffix
  (click)="hide = !hide"
  type="button"
  [attr.aria-label]="'Hide password'"
>
  <mat-icon *ngIf="to['type'] == 'password'">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>
          <input
            matInput
            type="time"
            id="{{ field.key }}"
            placeholder="{{ to.placeholder }}"
            *ngIf="to['type'] == 'time'"
            [formControl]="field.templateOptions.customControl"
            [readonly]="getReadonly() || getDisable()"
          />
        </mat-form-field>
        <div class="" *ngIf="showError">
          <mat-error *ngIf="field.formControl?.errors&&!field.props.readOnly">
            {{ getFirstErrorMessage(field.formControl?.errors) }}
          </mat-error>
        </div>
      </div>

      <div *ngIf="field.type === 'textarea'" class="input-wrappers-textarea">
        <mat-form-field
          style="width:100%"
          floatLabel="always"
          [ngClass]="{
            'mat-form-field-disabled': getDisable() || getReadonly(),
            'mat-form-field-invalid':
              field.formControl?.invalid &&
              (field.formControl?.dirty || field.formControl?.touched),
            '': !getDisable() || !getReadonly()
          }"
        >
          <label>
            <mat-label>
              <span class="label"
                ><span
                  ><em
                    *ngIf="to.labelIcon"
                    class="fa {{ to.labelIcon || '' }}"
                  ></em>
                  {{ to.label }}</span
                >
                <span *ngIf="to.required" class="required-icon">*</span></span
              >
              <!-- <mat-icon
                *ngIf="to['tooltip']"
                matTooltip="{{ to['tooltip'] }}"
                class="tooltipIcon"
                matTooltipPosition="right"
                >help</mat-icon
              > -->
            </mat-label>
          </label>
          <ng-container *ngIf="field.type === 'textarea' &&  (to['tooltip']||to['isTooltipVideoNeeded'])">
          <!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (mouseenter)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4">
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
    <!-- <video width="550" height="300" controls>
     <source type="video/mp4" [src]="videoUrl"/>
    </video> -->

    <iframe (mousedown)="$event.stopPropagation()"
    [src]="videoUrl"
    width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
   </iframe>
  </div>
</ng-template>
            </ng-container>
          <textarea
            matInput
            id="{{ field.key }}"
            placeholder="{{ to.placeholder }}"
            [formControl]="field.templateOptions.customControl"
          ></textarea>
        </mat-form-field>
        <div class="" *ngIf="showError">
          <mat-error *ngIf="field.formControl?.errors&&!field.props.readOnly">
            {{ getFirstErrorMessage(field.formControl?.errors) }}
          </mat-error>
        </div>
      </div>
      <div *ngIf="field.type === 'number'" class="input-wrappers">
        <mat-form-field
          style="width:100%"
          floatLabel="always"
          [ngClass]="{
            'mat-form-field-disabled': getDisable() || getReadonly(),
            'mat-form-field-invalid':
              field.formControl?.invalid &&
              (field.formControl?.dirty || field.formControl?.touched),
            '': !getDisable() || !getReadonly()
          }"
        >
          <label>
            <mat-label>
              <span class="label"
                >{{ to.label }}
                <span *ngIf="to.required" class="required-icon">*</span></span
              >
              <!-- <mat-icon
                *ngIf="to['tooltip']"
                matTooltip="{{ to['tooltip'] }}"
                class="tooltipIcon"
                matTooltipPosition="right"
                >help</mat-icon
              > -->
            </mat-label>
          </label>
          <ng-container *ngIf="field.type === 'number' && (to['tooltip']||to['isTooltipVideoNeeded'])">
            <!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (mouseenter)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4">
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
    <!-- <video width="550" height="300" controls>
     <source type="video/mp4" [src]="videoUrl"/>
    </video> -->

    <iframe (mousedown)="$event.stopPropagation()"
         [src]="videoUrl"
         width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>

  </div>
</ng-template>
        </ng-container>
          <input
            matInput
            id="{{ field.key }}"
            [formControl]="field.templateOptions.customControl"
            placeholder="{{ to.placeholder }}"
              (keypress)="restrictInput($event)"
          (input)="formatInput(field.formControl)"
           (paste)="restrictPaste($event)"
           (change)="formatInput(field.formControl)"
          />
        </mat-form-field>
        <div class="" *ngIf="showError">
          <mat-error *ngIf="field.formControl?.errors&&!field.props.readOnly">
            {{ getFirstErrorMessage(field.formControl?.errors) }}
          </mat-error>
        </div>
      </div>
      <div *ngIf="field.type === 'datepicker'" class="input-wrappers">
        <mat-form-field
          style="width:100%"
          floatLabel="always"
          [ngClass]="{
            'mat-form-field-disabled': getDisable() || getReadonly(),
            'mat-form-field-invalid':
              field.formControl?.invalid &&
              (field.formControl?.dirty || field.formControl?.touched),
            '': !getDisable() || !getReadonly()
          }"
        >
          <label>
            <mat-label>
              <span class="label"
                ><span
                  ><em
                    *ngIf="to.labelIcon"
                    class="fa {{ to.labelIcon || '' }}"
                  ></em>
                  {{ to.label }}</span
                >
                <span *ngIf="to.required" class="required-icon">*</span></span
              >

              <!-- <mat-icon
                *ngIf="to['tooltip']"
                matTooltip="{{ to['tooltip'] }}"
                class="tooltipIcon"
                matTooltipPosition="right"
                >help</mat-icon
              > -->
            </mat-label>
          </label>
          <ng-container *ngIf="field.type === 'datepicker' &&  (to['tooltip']||to['isTooltipVideoNeeded'])">
            <!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (mouseenter)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4" >
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div  (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
  <!-- <video width="550" height="300" controls>
      <source type="video/mp4" [src]="videoUrl"/>
    </video> -->

    <iframe (mousedown)="$event.stopPropagation()"
    [src]="videoUrl"
    width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
   </iframe>

  </div>
</ng-template>
        </ng-container>
          <input
            matInput
            id="{{ field.key }}"
            [matDatepicker]="picker"

            [min]="getMinDate()"
            [max]="getMaxDate()"
            [disabled]="getReadonly()"
            [formControl]="field.templateOptions.customControl"
            placeholder="Choose date"
            (click)="picker.open()"
            (input)="onDateInput($event)"
            (paste)="restrictDatePaste($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
             [ngClass]="{'hide-dateIcon': getReadonly()}"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="" *ngIf="showError">
          <mat-error *ngIf="field.formControl?.errors&&!field.props.readOnly">
            {{ getFirstErrorMessage(field.formControl?.errors) }}
          </mat-error>
        </div>
      </div>

      <div *ngIf="field.type === 'date-time-picker'" class="input-wrappers">
        <mat-form-field
          style="width:100%,height: fit-content"
          floatLabel="always"
        >
          <label>
            <mat-label>
              <span class="label"
                ><span
                  ><em
                    *ngIf="to.labelIcon"
                    class="fa {{ to.labelIcon || '' }}"
                  ></em>
                  {{ to.label }}</span
                >
                <span *ngIf="to.required" class="required-icon">*</span></span
              >

              <!-- <mat-icon
                *ngIf="to['tooltip']"
                matTooltip="{{ to['tooltip'] }}"
                class="tooltipIcon"
                matTooltipPosition="right"
                >help</mat-icon
              > -->
            </mat-label>
          </label>
          <ng-container
            *ngIf="field.type === 'date-time-picker' &&  (to['tooltip']||to['isTooltipVideoNeeded'])"
          >
          <!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (mouseenter)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4">
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
    <!-- <video width="550" height="300" controls>
     <source type="video/mp4" [src]="videoUrl"/>
    </video> -->

    <iframe (mousedown)="$event.stopPropagation()"
    [src]="videoUrl"
    width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
   </iframe>
  </div>
</ng-template>
        </ng-container>
          <mat-datetimepicker-toggle
            [for]="datePicker"
            matSuffix
          ></mat-datetimepicker-toggle>
          <mat-datetimepicker
            #datePicker
            type="datetime"
            [openOnFocus]="true"
            [timeInterval]="5"
          >
          </mat-datetimepicker>
          <input
            matInput
            id="{{ field.key }}"
            [formControl]="field.templateOptions.customControl"
            id="datetime"
            (click)="datePicker.open()"
            (input)="datePicker.open()"
            placeholder="Choose Date & Time"
            [matDatetimepicker]="datePicker"
            [max]="maxDate"
            [min]="minDate"
            autocomplete="false"
          />
          <!-- <input
            matInput
            id="{{ field.key }}"
            [ngxMatDatetimePicker]="picker"
            placeholder="Choose a date"
            [formControl]="field.templateOptions.customControl"
            [min]="minDate"
            [max]="maxDate"
            (click)="pickerFixed.open()"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerFixed"
          ></mat-datepicker-toggle>
          <ngx-mat-datetime-picker
            #picker
            [showSpinners]="showSpinners"
            [showSeconds]="showSeconds"
            [stepHour]="stepHour"
            [stepMinute]="stepMinute"
            [stepSecond]="stepSecond"
            [touchUi]="touchUi"
            [enableMeridian]="enableMeridian"
            [disableMinute]="disableMinute"
            [hideTime]="hideTime"
          >
          </ngx-mat-datetime-picker> -->
        </mat-form-field>

        <div class="" *ngIf="showError">
          <mat-error *ngIf="field.formControl?.errors&&!field.props.readOnly">
            {{ getFirstErrorMessage(field.formControl?.errors) }}
          </mat-error>
        </div>
      </div>

      <div *ngIf="field.type === 'quill-editor'" class="input-wrappers mt-3">
        <label>
          <mat-label>
            <span class="label"
              ><span
                ><em
                  *ngIf="to.labelIcon"
                  class="fa {{ to.labelIcon || '' }}"
                ></em>
                {{ to.label }}</span
              >
              <span *ngIf="to.required" class="required-icon">*</span></span
            >

            <!-- <mat-icon
              *ngIf="to['tooltip']"
              matTooltip="{{ to['tooltip'] }}"
              class="tooltipIcon"
              matTooltipPosition="right"
              >help</mat-icon
            > -->
          </mat-label>
        </label>
        <ng-container *ngIf="field.type === 'quill-editor' &&  (to['tooltip']||to['isTooltipVideoNeeded'])">
          <!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (mouseenter)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4">
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
    <!-- <video width="550" height="300" controls>
     <source type="video/mp4" [src]="videoUrl"/>
    </video> -->

    <iframe (mousedown)="$event.stopPropagation()"
    [src]="videoUrl"
    width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
   </iframe>
  </div>
</ng-template>
        </ng-container>
        <quill-editor
          [styles]="{ height: '120px' }"
          class="content-editor"
          id="{{ field.key }}"
          [modules]="quillConfiguration"
          [placeholder]="props['placeholder']"
          [readOnly]="to['readOnly']"
          [formControl]="field.templateOptions.customControl"
        ></quill-editor>
        <div class="" *ngIf="showError">
          <mat-error *ngIf="field.formControl?.errors&&!field.props.readOnly">
            {{ getFirstErrorMessage(field.formControl?.errors) }}
          </mat-error>
        </div>
      </div>
    </ng-template>
    <div *ngIf="field.type === 'radio'" class="input-wrappers mt-3">
      <label>
        <mat-label>
          <span class="label radioLabel">
          <span>
            <em *ngIf="to.labelIcon" class="fa {{ to.labelIcon || '' }}"></em>
            {{ to.label }}
          </span>
          <span *ngIf="to.required" class="required-icon">*</span>
        </span>
        </mat-label>
        <!-- <mat-icon
          *ngIf="to['tooltip']"
          matTooltip="{{ to['tooltip'] }}"
          class="tooltipIcon"
          matTooltipPosition="right"
          >help</mat-icon
        > -->
      </label>
      <ng-container *ngIf="field.type === 'radio' &&  (to['tooltip']||to['isTooltipVideoNeeded'])">
        <!-- Tooltip with HTML content -->
<em class="fa fa-info-circle icon" 
    [ngbTooltip]="htmlContent" 
    #t="ngbTooltip" 
    *ngIf="to?.tooltipType === 'html'||to?.tooltipType === 'plain'"
    (mouseenter)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip with Video content -->
<em class="fas fa-video icon" 
    [ngbTooltip]="htmlContentVideo" 
    #t="ngbTooltip" 
    *ngIf="to?.isTooltipVideoNeeded"
    (click)="t.open(); $event.stopPropagation()" 
    triggers="manual" 
    tooltipClass="my-custom-class" 
    placement="right"
    container="body">
</em>

<!-- Tooltip HTML Content (with innerHTML for 'html' type) -->
<ng-template #htmlContent class="ml-4">
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'html'" [innerHTML]="to['tooltip']"></div>
  <div (mousedown)="$event.stopPropagation()" *ngIf="to?.tooltipType === 'plain'">{{ to['tooltip'] }}</div>  <!-- Plain text binding -->
</ng-template>

<!-- Tooltip Video Content -->
<ng-template #htmlContentVideo>
  <div class="custom-tooltip-content">
    <!-- <video width="550" height="300" controls>
     <source type="video/mp4" [src]="videoUrl"/>
    </video> -->
    <iframe (mousedown)="$event.stopPropagation()"
    [src]="videoUrl"
    width="550" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
   </iframe>
     
  </div>
</ng-template>
        </ng-container>
      <br />
      <mat-radio-group
        id="{{ field.key }}"
        [formControl]="field.templateOptions.customControl"
      >
        @for(option of getOptions(); track option){
        <mat-radio-button
          class="mat-radio"
          [value]="option[to.valueProp ? to.valueProp : 'value']"
        >
          <span>
            <em class="fa {{ option.icon }}"></em>
            {{ option[to.labelProp ? to.labelProp : 'label'] }}
            <span
              *ngIf="
                option['isValueTooltipNeed'] &&
                option['valueTooltipText'] != ''
              "
            >
              <mat-icon
                *ngIf="option['valueTooltipType'] == 'plain'"
                matTooltip="{{ option['valueTooltipText'] }}"
                class="tooltipValueIcon"
                matTooltipPosition="right"
                >help</mat-icon
              >
              <ng-container *ngIf="option['valueTooltipType'] == 'html'">
                <em
                  class="fas fa-question-circle icon"
                  [ngbTooltip]="htmlContent"
                  #t="ngbTooltip"
                  (click)="t.open(); $event.stopPropagation()"
                  triggers="mouseenter"
                  tooltipClass="my-custom-class"
                  placement="right"
                ></em>

                <ng-template #htmlContent class="ml-4">
                  <div [innerHTML]="option['valueTooltipText']"></div>
                </ng-template>
              </ng-container>
            </span>
          </span>
        </mat-radio-button>
        }
      </mat-radio-group>
      <div class="" *ngIf="showError">
        <mat-error *ngIf="field.formControl?.errors&&!field.props.readOnly">
          {{ getFirstErrorMessage(field.formControl?.errors) }}
        </mat-error>
      </div>
    </div>
  </div>
`,
styles: [
  `
    // .mat-icon-button i,
    // .mat-icon-button .mat-icon {
    //   line-height: 14px !important;
    // }
    .radio {
      color: gray;
     
    }
      .radioLabel{
       font-family:Poppins, sans-serif !important;
      }
    .icon {
      font-size: 14px;
      margin-left: 5px;
      color: #817c7c;
    }
    .mat-radio {
      color: #817c7c;
    }
    // .mat-option[aria-disabled='true'].contains-mat-select-search .mat-icon {
    //   margin-top: -10px !important;
    //   font-size: 20px !important;
    // }
    .mat-mdc-form-field-subscript-wrapper {
      line-height: 0px !important;
    }
    .formly-tooltip-wrapper.invalid-field
      .mat-mdc-radio-group
      .mat-mdc-radio-button
      .mdc-radio__background
      .mdc-radio__outer-circle
      .mdc-checkbox__background {
      border-color: red !important;
    }
    .invalid-field {
      .mdc-text-field--filled:not(.mdc-text-field--disabled)
        .mdc-line-ripple::before {
        border-color: red !important;
      }
      .mdc-text-field--filled:not(.mdc-text-field--disabled)
        .mdc-line-ripple::after {
        border-bottom-color: red !important;
      }
      // .mat-mdc-radio-button
      //   .mdc-radio:hover
      //   .mdc-radio__native-control:not([disabled])
      //   ~ .mdc-radio__background
      //   .mdc-radio__outer-circle {
      //   border-color: red !important;
      // }
      // .mat-mdc-radio-button .mdc-radio__native-control:enabled:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle{
      //   border-color: red !important;
      // }
    }
    .input-wrappers mat-form-field {
      margin-bottom: -20px !important; /* Adjust the margin as needed */
      .mat-mdc-text-field-wrapper .mat-mdc-form-field-input-control {
        font-size: 14px !important;
      }
      .mat-mdc-select-trigger {
        font-size: 14px !important;
      }
      .mdc-text-field--filled {
        background-color: inherit !important;
      }
      .mdc-text-field--filled:hover {
        background-color: inherit !important;
      }
      .mat-mdc-form-field-focus-overlay {
        background-color: inherit !important;
      }
      .mat-mdc-form-field-infix {
        padding-top: 12px !important;
        padding-bottom: 4px !important;
      }
    }
    .mat-select-search-clear {
      .mat-icon {
        overflow: visible !important;
      }
    }
    .mat-datepicker-toggle .mat-mdc-icon-button.mat-mdc-button-base {
      --mdc-icon-button-state-layer-size: 35px !important;
      padding: 8px !important;
    }
    // .material-icons {
    //   font-size: 20px !important;
    // }
    // mat-icon {
    //   height: 14px !important;
    // }

    .space {
      padding-top: 1.25em;
    }

    .error-message {
      color: #f44336;
      font-size: 11px;
    }
    .required-icon {
      color: #ff5722; /* Customize the color of the star icon for required fields */
      //margin-left: 5px; /* Adjust the spacing as needed */
    }
    .tooltipIcon {
      // font-size: 16.2px;
      font-size: 12px;
      margin-left: 3px;
      color: #817c7c;
      margin-bottom: 0.5px;
    }
    .tooltipValueIcon {
      font-size: 16.2px;
      margin-left: 3px;
      color: #817c7c;
    }
    .formly-tooltip-wrapper mat-label {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.54);
    }

    .mat-mdc-checkbox .mat-internal-form-field {
      font-size: 16px !important;
      color: #0000008a !important;
    }
    .mat-mdc-radio-button .mat-internal-form-field {
      font-size: 15px !important;
      color: #0000008a !important;
    }
    .valueIcon {
      margin-bottom: 6px !important;
    }
    .custom-select-panel {
      margin-bottom: 6.5%;
    }
    ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
      background-color: none !important;
    }
    .mat-datetimepicker-calendar-content {
      background: white !important;
    }
    .mat-datetimepicker-calendar-header {
      background: #3f51b5 !important;
      color: white !important;
    }

    .mat-datetimepicker-calendar[mode='auto'] {
      display: flex;
      width: 400px !important;
      height: 260px !important;
    }

    .mat-datetimepicker-clock-cell.mat-datetimepicker-clock-cell-selected[_ngcontent-ldo-c447] {
      color: #446ab1 !important;
    }

    .mat-button-toggle-standalone.mat-button-toggle-appearance-standard:not(
        [class*='mat-elevation-z']
      ),
    .mat-button-toggle-group-appearance-standard:not(
        [class*='mat-elevation-z']
      ) {
      width: 100%;
      height: 40px;
    }

    .mat-icon {
      width: 20px !important;
    }
    .material-icons {
      font-size: 16px !important;
    }

    .mat-mdc-icon-button svg {
      --mdc-icon-button-icon-size: 20px !important;
    }
    .my-custom-class .arrow::before {
      border-top-color: #7e7a7a;
    }
    .my-custom-class {
      max-width: 700px;  /* Adjust width */
      max-height: 353px; /* Set max height */
      opacity:1 !important;
      overflow-y: auto;  /* Enable scrolling if content exceeds */
      background: white;
      color: black;
      padding: 10px;
      border-radius: 5px;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
      z-index:10000 !important;
    }
    
    .custom-tooltip-content {
      padding: 10px;
      font-size: 14px;
    }

    .my-custom-class .tooltip-inner{
      max-width: 3000px;  /* Adjust width */
      max-height: 2050px; /* Set max height */
      background-color: white;
      font-size: 14px;
      margin-left: 5px;
      color: black !important;
    }
    .tooltip .tooltip-arrow {
      margin-left: 5px;
    }
    .hide-dropdown .mat-mdc-select-arrow-wrapper {
display: none !important;
}
.hide-dateIcon 
{
display: none !important;
}
label{
height: 35px !important;
  line-height: 17px;
}

mat-radio-button label{
height: 35px !important;
  line-height: 33px !important;
}

.custom-dropdown-panel.mat-mdc-select-panel-above {
bottom: 100px !important;
transform: translateY(-10px) !important;
max-height: 250px !important;
}
.mat-calendar-body-today{
border:1px solid white !important;
background-color:white !important;
color: black !important;
box-shadow: none !important;
}
.mat-calendar-body-selected{
/* Custom style when both classes are applied */
background-color: #3f51b5 !important;
color: white !important;  
border:1px solid #00000000 !important; /* Example: Change the text color */
}
.mat-calendar-body-today:hover{
background-color:rgb(202, 208, 243)!important; /* Change background color on hover */
}
.mat-calendar-body-disabled .mat-calendar-body-today{
color:#00000061 !important;
}
.mat-calendar-body-disabled .mat-calendar-body-today:hover {
background-color:white !important;
}
/* Override the background color for highlighted dates (e.g., minimum date) */
.mat-focus-indicator:focus {
outline: none !important;
background: none !important;
}
.cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical) {
  background-color: white !important;
}
.cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical):hover {
background-color:rgb(202, 208, 243)!important; /* Change background color on hover */
}
  `,
],
encapsulation: ViewEncapsulation.None,
providers: [
  {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TooltipIconWrapperComponent),
    multi: true,
  },
],
})
export class TooltipIconWrapperComponent
  extends FieldWrapper
  implements OnInit, AfterViewInit {
  customControl = new FormControl();
  quillConfiguration = QuillConfiguration;
  isGrid = false;
  optionsArray: any;
  minDate: Date | null = null; // Set your minDate value
  maxDate: Date | null = null; // Set your maxDate value
  disabled = false; // Set disabled status
  showSpinners = true; // Adjust as needed
  showSeconds = false; // Adjust as needed
  stepHour = 1; // Adjust as needed
  stepMinute = 1; // Adjust as needed
  stepSecond = 1; // Adjust as needed
  touchUi = false; // Adjust as needed
  color = 'primary'; // Adjust as needed
  enableMeridian = false; // Adjust as needed
  disableMinute = false; // Adjust as needed
  hideTime = false; // Adjust as needed
  @ViewChild('picker') pickerFixed?: any;
  @ViewChild('searchInput') searchInput: ElementRef;
  fields: FormlyFieldConfig[] = [];
  hide = true;
  videoUrl: SafeResourceUrl;
  getOptions() {
    this.optionsArray = this.field.props?.options || [];
    return this.optionsArray;
  }
  // restrictInput(event: KeyboardEvent) {
  //   // const pattern = /[0-9.]/;

  //   const field = this.field;
  //   field.templateOptions.isDecimalAllowed = true;
  //   const pattern = field.templateOptions.isDecimalAllowed ? /^[0-9.]*$/ : /^[0-9]*$/;
  //   const inputChar = String.fromCharCode(event.keyCode);

  //   // Prevent non-numeric and non-dot characters during typing
  //   if (!pattern.test(inputChar) && event.keyCode !== 8) { // Allow backspace
  //     event.preventDefault();
  //   }
  // }
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  onDateInput(event: any) {
    this.field.formControl.markAsTouched();
    const format = 'DD/MM/YYYY';
    const inputValue = event.target.value;
    const isValidDate = moment(inputValue, format, true).isValid();

    if (isValidDate) {

      const date = this.parseDateFromString(inputValue);
      // const date = inputValue;

      let minVal = null;
      let maxVal = null;

      if (this.field?.templateOptions.datepickerOptions.min != null) {
        minVal = this.field?.templateOptions.datepickerOptions.min
      }
      if (this.field?.templateOptions.datepickerOptions.max != null) {
        maxVal = this.field?.templateOptions.datepickerOptions.max
      }



      // If the entered value is a valid date
      if (date) {


        // Parse input date and min/max dates, stripping time by using moment and native Date
        const dateVal = moment(date, 'DD/MM/YYYY').startOf('day');
        const minDate = moment(minVal).startOf('day');
        const maxDate = moment(maxVal).startOf('day');


        if ((minDate || maxDate) && (dateVal < minDate || dateVal > maxDate)) {
          this.field.formControl.setValue(date); // Set the valid date to form control
          this.field.templateOptions.customControl.setValue(date)
          this.field.formControl.setErrors({ invalidDate: true }); // Set error if it's invalid
          this.field.templateOptions.customControl.setErrors({ invalidDate: true }); // Set error if it's invalid
        }
        else {
          this.field.formControl.setValue(date); // Set the valid date to form control
          this.field.templateOptions.customControl.setValue(date)
          // this.picker.select(date); // Update the date picker with the selected date
        }
      }
    } else {
      this.field.formControl.setErrors({ invalidDate: true }); // Set error if it's invalid
      this.field.templateOptions.customControl.setErrors({ invalidDate: true }); // Set error if it's invalid
    }

  }



  // Helper function to parse "dd/MM/yyyy" format
  parseDateFromString(dateString: string): Date | null {
    const parts = dateString.split('/');

    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // Months are zero-based in JavaScript Date
      const year = parseInt(parts[2], 10);

      const date = new Date(year, month, day);

      // Check if the date is valid (i.e., not NaN)
      if (!isNaN(date.getTime())) {
        return date;
      }
    }

    return null; // Return null if invalid
  }



  restrictInput(event: KeyboardEvent) {
    const field = this.field; // Assuming you have access to `field` in this context
    const inputChar = String.fromCharCode(event.keyCode);

    // Check if the current value already contains a decimal point
    const currentValue = field.formControl.value || '';

    // Create a pattern based on whether decimals are allowed
    const pattern = field.templateOptions.isDecimalAllowed
      ? /^[0-9.]*$/
      : /^[0-9]*$/;

    // Prevent non-numeric characters during typing
    if (!pattern.test(inputChar) && event.keyCode !== 8) { // Allow backspace
      event.preventDefault();
    }

    // Prevent more than one decimal point if decimals are allowed
    if (field.templateOptions.isDecimalAllowed && inputChar === '.') {
      if (currentValue.includes('.')) {
        event.preventDefault();
      }
    }
  }

  restrictPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedData = clipboardData.getData('text');

    // Replace all valid characters (numbers and dots), then check if anything is left.
    // If there's any invalid character, prevent the paste.
    if (/[^0-9.]/.test(pastedData)) {
      event.preventDefault();  // Block the paste
    }
  }

  restrictDatePaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedData = clipboardData.getData('text');

    // Regular expression for DD/MM/YYYY format
    const datePattern = /^([0-2]\d|3[01])\/(0\d|1[0-2])\/\d{4}$/;

    // Test the pasted data against the date pattern
    if (!datePattern.test(pastedData)) {
      event.preventDefault();  // Block the paste if it doesn't match DD/MM/YYYY
    }
  }


  formatInput(formControl: any): void {
    let input = formControl.value;

    // Check if it's a number and convert it to a string
    input = input ? input.toString() : '';

    // Remove all commas from input to keep unformatted value for validation
    let unformattedValue = this.field.templateOptions.isDecimalAllowed == true ? input.replace(/[^0-9.]/g, '') : input.replace(/[^0-9]/g, '');

    // Prepare an array to hold validators
    const validatorsArray = [];


    if (this.field.templateOptions?.required) {
      validatorsArray.push(Validators.required);
    }


    formControl.setValidators(validatorsArray);
    this.field.templateOptions?.customControl.setValidators(validatorsArray);

    let key: any = this.field.key;


    if (this.field.templateOptions.isCommaSeparation) {
      // Apply the comma format for display purpose
      const formattedInput = this.formatNumber(unformattedValue);
      // (document.getElementById(key) as HTMLInputElement).value = formattedInput;
      // Set raw value to the form control
    formControl?.setValue(formattedInput, { emitEvent: false });
    this.field.templateOptions?.customControl.setValue(formattedInput, { emitEvent: false });
    // formControl.updateValueAndValidity(); // Revalidate after setting/clearing validators
    // this.field.templateOptions?.customControl.updateValueAndValidity();
    }
   
    // Check if input is non-empty
    if (unformattedValue.length > 0) {
      // Check and add min validator if applicable

      if (this.field.templateOptions.min !== undefined && this.field.templateOptions.min !== null && this.field.templateOptions.hasOwnProperty('min')) {
        // validatorsArray.push(Validators.min(this.field.templateOptions.min));
        const minValue = this.field.templateOptions.min;
        if (parseFloat(unformattedValue) < minValue) {
          formControl.setErrors({ min: { max: minValue, actual: parseFloat(unformattedValue) } });
          this.field.templateOptions?.customControl.setErrors({ min: { max: minValue, actual: parseFloat(unformattedValue) } });
        }
      }

      // Check and add max validator if applicable
      if (this.field.templateOptions.max !== undefined && this.field.templateOptions.max !== null && this.field.templateOptions.hasOwnProperty('max')) {
        const maxValue = this.field.templateOptions.max;
        
        if (parseFloat(unformattedValue) > maxValue) {
          // Set the error on formControl and customControl
          formControl.setErrors({ max: { max: maxValue, actual: parseFloat(unformattedValue) } });
          this.field.templateOptions?.customControl.setErrors({ max: { max: maxValue, actual: parseFloat(unformattedValue) } });
        }
      }
      
      if (this.field.templateOptions.minLength !== undefined && this.field.templateOptions.minLength !== null && this.field.templateOptions.hasOwnProperty('minLength')) {
        const minLength = this.field.templateOptions.minLength;
        if (unformattedValue.length < minLength) {
          formControl.setErrors({ minLength: { min: minLength, actual: unformattedValue.length } });
          this.field.templateOptions?.customControl.setErrors({ minLength: { min: minLength, actual: unformattedValue.length } });
        }
      }
  
      // Check and add max validator if applicable
      if (this.field.templateOptions.maxLength !== undefined && this.field.templateOptions.maxLength !== null && this.field.templateOptions.hasOwnProperty('maxLength')) {
        const maxLength = this.field.templateOptions.maxLength;
        if (unformattedValue.length > maxLength) {
          formControl.setErrors({ maxLength: { max: maxLength, actual: unformattedValue.length } });
          this.field.templateOptions?.customControl.setErrors({ maxLength: { max: maxLength, actual: unformattedValue.length } });
        }
      }
       // Check and add max validator if applicable
        if (this.field.templateOptions.pattern !== undefined && this.field.templateOptions.pattern !== null && this.field.templateOptions.hasOwnProperty('pattern')) {
          const regex = new RegExp(this.field.templateOptions?.pattern);
        
          if (!regex.test(unformattedValue)) {
            // Set error for the form control if the pattern doesn't match
            formControl.setErrors({
              pattern: {
                requiredPattern: this.field.templateOptions.pattern,
                actualValue: unformattedValue,
              },
            });
        
            // Set error for custom control if it exists
            if (this.field.templateOptions?.customControl) {
              this.field.templateOptions.customControl.setErrors({
                pattern: {
                  requiredPattern: this.field.templateOptions.pattern,
                  actualValue: unformattedValue,
                },
              });
            }
          
        }
        
      }
    } else {
      // If the input is empty, clear the validators
      formControl.clearValidators();
      this.field.templateOptions?.customControl.clearValidators();
    }

  

   
    // formControl.updateValueAndValidity(); // Revalidate after setting/clearing validators
    // this.field.templateOptions?.customControl.updateValueAndValidity();
  }

  // Formatting method for adding commas
  formatNumber(value: string): string {
    if (!value) return '';  // Handle empty value
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  // Method to patch value and apply formatting

  //use blur method to send comma values
  finalizeInput() {
    let value = this.field.formControl?.value;

    // Remove commas for validation purposes
    const unformattedValue = value.replace(/,/g, '');
    this.field.formControl?.updateValueAndValidity();

    // Reformat the input with commas for display
    const formattedInput = this.formatNumber(unformattedValue)

    // Set the final formatted value into the form control
    this.field.formControl?.setValue(formattedInput, { emitEvent: false });
  }
  //indian format
  // formatNumber(value: string): string {
  //   const parts = value.split('.');
  //   parts[0] = this.formatIndianNumber(parts[0]);
  //   return parts.join('.');
  // }

  // formatIndianNumber(value: string): string {
  //   let lastThree = value.substring(value.length - 3);
  //   const otherNumbers = value.substring(0, value.length - 3);
  //   if (otherNumbers !== '') {
  //     lastThree = ',' + lastThree;
  //   }
  //   const formattedNumber = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
  //   return formattedNumber;
  // }
  ngOnInit() {
    this.fields = this.formlyApiService.getdata();
    this.field.props.customControl = new FormControl();
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.field.props?.videoUrl);
    setTimeout(() => {
      if (this.field.type == "number" && this.field.defaultValue) {
        this.formatInput(this.field.formControl)
      }
    }, 0);


    let isRequired = this.field?.templateOptions?.required;

    if (isRequired) {
      if (this.field?.formControl) {
        this.field.formControl.statusChanges.subscribe((status) => {
          if (this.field.formControl.touched) {
            this.cdr.detectChanges();
          }
        });
      }
    }

    this.field.props.customControl = new FormControl({
      value: null,
      disabled: this.getDisable() || this.getReadonly(),
    });

    if (this.field.defaultValue) {
      if (this.field['type'] === 'radio') {
        let defaultvalue = this.field.defaultValue;
        if (typeof defaultvalue === 'boolean') {
          this.field.formControl?.setValue(
            this.field.defaultValue === true ? 'true' : 'false'
          );
          this.field.props.customControl?.setValue(
            this.field.defaultValue === true ? 'true' : 'false'
          );
        } else {
          this.field.formControl?.setValue(this.field.defaultValue);
          this.field.props.customControl.patchValue(
            this.field.defaultValue ?? ''
          );
        }
      } else {
        this.field.props.customControl.patchValue(
          this.field.defaultValue ?? ''
        );
      }
    }

    this.field.props.customControl.valueChanges.subscribe((value) => {
      this.field.formControl?.setValue(value); // Update the actual Formly control's value
      this.field.defaultValue = value;
    });


    if (!this.field.validation.messages.invalidDate && this.field.type == "datepicker") {
      let key = this.field?.props?.label
      this.field.validation = {
        messages: {
          invalidDate: key ? `${key} is invalid` : 'The date you entered is invalid. Please correct it.',
        }
      }
    }

  }




  constructor(public el: ElementRef, private cdr: ChangeDetectorRef, private formlyApiService: FormlyApiService, private sanitizer: DomSanitizer) {
    super();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // this.checkAutofill();
    }, 500); // Delay to allow autofill to be applied
    this.removeAriaOwns();
  }
  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     this.checkAutofill();
  //   }, 500); // Delay to allow autofill to be applied
  //   this.removeAriaOwns();
  // }

  // checkAutofill() {
  //   const key: any = this.field.key;
  //   const inputElement = document.getElementById(key) as HTMLInputElement;
  //   const autofillValue = inputElement?.value;

  //   if (autofillValue) {
  //     this.formatInput(this.field.formControl);
  //   }
  // }


  removeAriaOwns() {
    // const parentElement = this.el.nativeElement.parentElement;
    const element = this.el.nativeElement.querySelectorAll(
      '.mat-form-field-label'
    );

    element.forEach((el) => {
      if (el && el.hasAttribute('aria-owns')) {
        el.removeAttribute('aria-owns');
      }
    });
  }

  getTemplateOptionsValidators(): any {
    const validators: Validators[] = [];

    if (this.props.required) {
      validators.push(Validators.required);
    }

    if (this.props.pattern) {
      validators.push(Validators.pattern(this.props.pattern));
    }

    if (this.props.minLength) {
      validators.push(Validators.minLength(this.props.minLength));
    }

    if (this.props.maxLength) {
      validators.push(Validators.maxLength(this.props.maxLength));
    }
    return validators;
  }
  // getFirstErrorMessage(errors: any) {
  //   if (errors) {
  //     const firstErrorKey = Object.keys(errors)[0];
  //     return this.field.validation?.messages?.[firstErrorKey] ?? '';
  //   }
  //   return '';
  // }
  getFirstErrorMessage(errors: any) {
    if (errors) {
      const firstErrorKey = Object.keys(errors)[0];
      // Normalize the firstErrorKey by converting to lowercase
      const normalizedKey = firstErrorKey.toLowerCase();

      // Iterate over validation messages to find the matching one
      for (const key in this.field.validation?.messages) {
        if (key.toLowerCase() === normalizedKey) {
          return this.field.validation?.messages?.[key];
        }
      }
    }
    return '';
  }


  getMinDate() {
    return this.field.props?.datepickerOptions?.min;
  }

  getMaxDate() {
    return this.field.props?.datepickerOptions?.max;
  }

  getReadonly() {
    return !!this.field.props?.readOnly;
  }

  getDisable() {
    // return !!this.field.props?.readOnly;
    return !!this.field.props?.disabled;
  }

  onDropdownOpened(opened: boolean): void {
    if (opened) {
      // Delay to ensure the searchInput is available
      setTimeout(() => {
        if (this.searchInput && this.searchInput.nativeElement) {
          this.searchInput.nativeElement.removeAttribute('inert');
          this.searchInput.nativeElement.focus();
        }
      }, 0);
    } else {
      if (this.searchInput && this.searchInput.nativeElement) {
        this.searchInput.nativeElement.setAttribute('inert', '');
      }
    }
  }
}

